Billy.Posting.registerFilter('minEntryDate', ['entryDate'], function(data, minEntryDate) {
    return moment(Em.get(data, 'entryDate')).isAfter(minEntryDate)
})
